<template>
  <div>
    <div class="main">
      <!-- Right -->
      <div class="main_r">
        <!-- search -->
       <div class="search">
          <div>
            <!-- <el-date-picker v-model="queryData.dayDate" type="date" value-format="yyyy-MM-dd" placeholder="日期" class="mr15"></el-date-picker> -->
            <!-- <el-button type="primary" @click="clickQuery">查询</el-button> -->
            <!-- <el-button type="primary" @click="clickQueryReset" plain>重置</el-button> -->
            <el-button type="primary" @click="clickBack">返回</el-button>
          </div>
        </div>
        <!-- search End -->

        <!-- 列表 -->
        <el-table :data="dataList" class="mt15" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }" @sort-change="handleSortChange">
          <el-table-column prop="id" label="序号" min-width="10%" sortable="custom"></el-table-column>
          <el-table-column prop="vweightKg" label="体重" min-width="20%" sortable="custom">
            <template slot-scope="props">
              {{props.row.vweightKg}}Kg 【{{props.row.sweightKg}}】
            </template>
          </el-table-column>
          <el-table-column prop="bmi" label="BMI" min-width="20%" sortable="custom">
            <template slot-scope="props">
              {{props.row.vbmi}} 【{{props.row.sbmi}}】
            </template>
          </el-table-column>
          <el-table-column prop="moistureRate" label="水份率" min-width="20%" sortable="custom">
            <template slot-scope="props">
              {{props.row.vwaterPercentage}}% 【{{props.row.swaterPercentage}}】
            </template>
          </el-table-column>
          <el-table-column prop="boneRate" label="骨骼肌率" min-width="20%" sortable="custom">
            <template slot-scope="props">
              {{props.row.vbodySkeletal}}% 【{{props.row.sbodySkeletal}}】
            </template>
          </el-table-column>
          <el-table-column prop="bodyAge" label="身体年龄" min-width="20%" sortable="custom">
            <template slot-scope="props">
              {{props.row.vbodyAge}}岁 【{{props.row.sbodyAge}}】
            </template>
          </el-table-column>
          <el-table-column prop="fatRate" label="体脂率" min-width="20%" sortable="custom">
            <template slot-scope="props">
              {{props.row.vfat}}% 【{{props.row.sfat}}】
            </template>
          </el-table-column>
          <el-table-column prop="visceralFatRate" label="内脏脂肪" min-width="20%" sortable="custom">
            <template slot-scope="props">
              {{props.row.vvisceralFat}} 【{{props.row.svisceralFat}}】
            </template>
          </el-table-column>
          <el-table-column prop="muscleRate" label="肌肉率" min-width="20%" sortable="custom">
            <template slot-scope="props">
              {{props.row.vmusclePercentage}}% 【{{props.row.smusclePercentage}}】
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" min-width="25%" sortable="custom"></el-table-column>
          <el-table-column prop="Operation" label="操作" min-width="10%">
            <template slot-scope="props">
              <el-tooltip class="item" effect="dark" content="查看详情" placement="top" :enterable="false">
                <el-link :underline="false" type="primary" icon="el-icon-edit" class="mr12" @click="clickdialogEdit(props.row)"></el-link>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="mt20">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page_no"
            :page-sizes="[5, 10, 15, 20]"
            :page-size="5"
            layout="prev, pager, next, sizes, jumper "
            :total="dataListnum">
          </el-pagination>
        </div>
        <!-- 分页 End -->
      </div>
      <!-- Right End -->

      <!-- 查看详情 -->
      <el-dialog title="查看详情" :visible.sync="dialogEdit" width="35%" class="newAdd">
        <div class="addUser_body">
          <el-form ref="userMsg" :model="editData" label-width="100px">
            <el-form-item label="体重"><el-input v-model="editData.vweightKg" placeholder="请输入"><template slot="append">
                <span style="width: 100px; display: inline-block;text-align: center;">{{ editData.sweightKg }}</span></template>
            </el-input></el-form-item>
            <el-form-item label="理想体重"><el-input v-model="editData.vbodyStandardWeightKg" placeholder="请输入"><template slot="append">
                <span style="width: 100px; display: inline-block;text-align: center;">{{ editData.sbodyStandardWeightKg }}</span></template>
            </el-input></el-form-item>
            <el-form-item label="BMI"><el-input v-model="editData.vbmi" placeholder="请输入"><template slot="append">
                <span style="width: 100px; display: inline-block;text-align: center;">{{ editData.sbmi }}</span></template>
            </el-input></el-form-item>
            <el-form-item label="BMR"><el-input v-model="editData.vbmr" placeholder="请输入"><template slot="append">
                <span style="width: 100px; display: inline-block;text-align: center;">{{ editData.sbmr }}</span></template>
            </el-input></el-form-item>
            <el-form-item label="腰臀比"><el-input v-model="editData.vwhr" placeholder="请输入"><template slot="append">
                <span style="width: 100px; display: inline-block;text-align: center;">{{ editData.swhr }}</span></template>
            </el-input></el-form-item>
            <el-form-item label="内脏脂肪"><el-input v-model="editData.vvisceralFat" placeholder="请输入"><template slot="append">
                <span style="width: 100px; display: inline-block;text-align: center;">{{ editData.svisceralFat }}</span></template>
            </el-input></el-form-item>
            <el-form-item label="体脂率"><el-input v-model="editData.vfat" placeholder="请输入"><template slot="append">
                <span style="width: 100px; display: inline-block;text-align: center;">{{ editData.sfat }}</span></template>
            </el-input></el-form-item>
            <el-form-item label="骨骼肌率"><el-input v-model="editData.vbodySkeletal" placeholder="请输入"><template slot="append">
                <span style="width: 100px; display: inline-block;text-align: center;">{{ editData.sbodySkeletal }}</span></template>
            </el-input></el-form-item>
            <el-form-item label="骨骼肌量"><el-input v-model="editData.vbodySkeletalKg" placeholder="请输入"><template slot="append">
                <span style="width: 100px; display: inline-block;text-align: center;">{{ editData.sbodySkeletalKg }}</span></template>
            </el-input></el-form-item>
            <el-form-item label="左臂肌肉量"><el-input v-model="editData.vmuscleKgLeftArm" placeholder="请输入"><template slot="append">
                <span style="width: 100px; display: inline-block;text-align: center;">{{ editData.smuscleKgLeftArm }}</span></template>
            </el-input></el-form-item>
            <el-form-item label="右臂肌肉量"><el-input v-model="editData.vmuscleKgRightArm" placeholder="请输入"><template slot="append">
                <span style="width: 100px; display: inline-block;text-align: center;">{{ editData.smuscleKgRightArm }}</span></template>
            </el-input></el-form-item>
            <el-form-item label="左臂脂肪比率"><el-input v-model="editData.vbodyFatRateLeftArm" placeholder="请输入"><template slot="append">
                <span style="width: 100px; display: inline-block;text-align: center;">{{ editData.sbodyFatRateLeftArm }}</span></template>
            </el-input></el-form-item>
            <el-form-item label="右臂脂肪比率"><el-input v-model="editData.vbodyFatRateRightArm" placeholder="请输入"><template slot="append">
                <span style="width: 100px; display: inline-block;text-align: center;">{{ editData.sbodyFatRateRightArm }}</span></template>
            </el-input></el-form-item>
            <el-form-item label="左腿肌肉量"><el-input v-model="editData.vmuscleKgLeftLeg" placeholder="请输入"><template slot="append">
                <span style="width: 100px; display: inline-block;text-align: center;">{{ editData.smuscleKgLeftLeg }}</span></template>
            </el-input></el-form-item>
            <el-form-item label="右腿肌肉量"><el-input v-model="editData.vmuscleKgRightLeg" placeholder="请输入"><template slot="append">
                <span style="width: 100px; display: inline-block;text-align: center;">{{ editData.smuscleKgRightLeg }}</span></template>
            </el-input></el-form-item>
            <el-form-item label="左腿脂肪比率"><el-input v-model="editData.vbodyFatRateLeftLeg" placeholder="请输入"><template slot="append">
                <span style="width: 100px; display: inline-block;text-align: center;">{{ editData.sbodyFatRateLeftLeg }}</span></template>
            </el-input></el-form-item>
            <el-form-item label="右腿脂肪比率"><el-input v-model="editData.vbodyFatRateRightLeg" placeholder="请输入"><template slot="append">
                <span style="width: 100px; display: inline-block;text-align: center;">{{ editData.sbodyFatRateRightLeg }}</span></template>
            </el-input></el-form-item>
            <el-form-item label="躯干肌肉量"><el-input v-model="editData.vmuscleKgTrunk" placeholder="请输入"><template slot="append">
                <span style="width: 100px; display: inline-block;text-align: center;">{{ editData.smuscleKgTrunk }}</span></template>
            </el-input></el-form-item>
            <el-form-item label="躯干脂肪比率"><el-input v-model="editData.vbodyFatRateTrunk" placeholder="请输入"><template slot="append">
                <span style="width: 100px; display: inline-block;text-align: center;">{{ editData.sbodyFatRateTrunk }}</span></template>
            </el-input></el-form-item>
            <el-form-item label="水分率"><el-input v-model="editData.vwaterPercentage" placeholder="请输入"><template slot="append">
                <span style="width: 100px; display: inline-block;text-align: center;">{{ editData.swaterPercentage }}</span></template>
            </el-input></el-form-item>
            <el-form-item label="皮下脂肪率"><el-input v-model="editData.vbodyFatSubCutPercentage" placeholder="请输入"><template slot="append">
                <span style="width: 100px; display: inline-block;text-align: center;">{{ editData.sbodyFatSubCutPercentage }}</span></template>
            </el-input></el-form-item>
            <el-form-item label="身体年龄"><el-input v-model="editData.vbodyAge" placeholder="请输入"><template slot="append">
                <span style="width: 100px; display: inline-block;text-align: center;">{{ editData.sbodyAge }}</span></template>
            </el-input></el-form-item>
            <el-form-item label="健康评价"><el-input v-model="editData.vbodyHealth" placeholder="请输入"><template slot="append">
                <span style="width: 100px; display: inline-block;text-align: center;">{{ editData.sbodyHealth }}</span></template>
            </el-input></el-form-item>
            <el-form-item label="健康评分"><el-input v-model="editData.vbodyScore" placeholder="请输入"><template slot="append">
                <span style="width: 100px; display: inline-block;text-align: center;">{{ editData.sbodyScore }}</span></template>
            </el-input></el-form-item>
            <el-form-item label="肌肉率"><el-input v-model="editData.vmusclePercentage" placeholder="请输入"><template slot="append">
                <span style="width: 100px; display: inline-block;text-align: center;">{{ editData.smusclePercentage }}</span></template>
            </el-input></el-form-item>
            <el-form-item label="肥胖等级"><el-input v-model="editData.vbodyFatGrade" placeholder="请输入"><template slot="append">
                <span style="width: 100px; display: inline-block;text-align: center;">{{ editData.sbodyFatGrade }}</span></template>
            </el-input></el-form-item>
          </el-form>
        </div>
      </el-dialog>
      <!-- 查看详情 End -->

    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {},
  data () {
    return {
      activeName: 'first',
      formLabelWidth: '120px',
      queryData: {
        terminalUserId: ''
      },
      // 列表
      dataList: [],
      dataListnum: 0,
      page_no: 1,
      page_size: 5,
      sortField: '',
      sortOrder: '',
      // 编辑
      dialogEdit: false,
      editData: {},
    }
  },
  mounted () {
  },
  methods: {
    LoadData (row) {
      this.queryData.terminalUserId = row.id
      this.BodyFatScalesList()
      this.BodyFatScalesNum()
    },
    handleSortChange ({ prop, order }) {
      this.sortField = prop || ''
      this.sortOrder = order === 'ascending' ? 'asc' : (order === 'descending' ? 'desc' : '')
      this.page_no = 1
      this.BodyFatScalesList()
      this.BodyFatScalesNum()
    },
    handleSizeChange (val) {
      this.page_size = val
      this.BodyFatScalesList()
      this.BodyFatScalesNum()
    },
    handleCurrentChange (val) {
      this.page_no = val
      this.BodyFatScalesList()
      this.BodyFatScalesNum()
    },
    clickQuery () {
      this.page_no = 1
      this.BodyFatScalesList()
      this.BodyFatScalesNum()
      console.log(this.queryData)
    },
    clickQueryReset () {
      this.clickQuery()
    },
    clickBack () {
      this.$emit('triggerFunc', '')
    },
    clickdialogEdit (row) {
      this.dialogEdit = true
      this.editData = row
      console.log(this.editData)
    },
    BodyFatScalesList: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.terminalUserId = that.queryData.terminalUserId
      data.pageNo = that.page_no
      data.pageSize = that.page_size
      data.sortField = that.sortField
      data.sortOrder = that.sortOrder
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_BodyFatScalesList, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.dataList = response.data.data
          }
          console.log(response.data)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    BodyFatScalesNum: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.terminalUserId = that.queryData.terminalUserId
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_BodyFatScalesNum, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.dataListnum = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;

  .el-input {
    width: 300px;
    margin-right: 15px;
  }

  .el-select{
    margin-right: 15px;
  }
}

@media ( max-width: 1440px) {
  .search {
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .el-input {
      width: 120px;
      margin-right: 15px;
    }

    .el-select{
      margin-right: 15px;
      width: 130px;
    }
  }
}

.el-table thead {
  color: #666;
}

.el-form-item {
  margin-bottom: 16px;
}

.jingwei {
  margin-top: -8px;

  .zuobiao{
    margin-bottom: -10px;

    p {
      margin: 0;
    }

    & p:nth-child(2){
      margin-top: -10px;
    }
  }
}

.position{
  overflow: hidden;
  height: 332px;
  background: #f7f7f7;
}

/deep/ .el-table thead {
  color: #373735;
  font-weight: 500;
}

/deep/ .el-table th, .el-table tr {
  background: #eff3ff;
}

.newAdd /deep/ .el-dialog__footer {
  padding: 20px;
  text-align: center;
  border-top: 1px solid #f2f2f2;
}

.newAdd /deep/ .el-dialog__header {
  padding: 15px 20px 15px;
  background: #f6f6fa;
}
.newAdd /deep/ .el-dialog__headerbtn {
  top: 20px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.addUser_body{
  padding: 0 46px 0 30px;
}

/deep/ .el-button--primary {
  color: #FFF;
  background-color: #4976ff;
  border-color: #4976ff;
}

/deep/ .el-button--primary.is-plain {
  color: #4976ff;
  background: #eff3ff;
  border-color: #4976ff;
}

// 圆角处理
/deep/ thead tr th:nth-child(1) {
  border-radius: 10px 0 0 0;
}
/deep/ thead tr th:nth-last-child(2) {
  border-radius: 0 10px 0 0;
}
</style>
